import api from "api/config";

export const deleteHotelAPI = async (hotelId) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/hotels/${hotelId}/softDelete`,
  });

  return response;
};

export const UploadLogoAPI = async ({ id, fileName, contentType, dataBase64 }) => {
  const response = await api({
    method: "POST",
    url: `api/v1/hotels/${id}/upload-brand-logo`,
    data: {
      fileName,
      contentType,
      dataBase64,
    },
  });

  return response;
};
